import { req } from 'react-reqq-lite';
import { formatCurrency, formatNumber, formatSort, reqLoader } from 'helper';
import * as c from './constants';
import * as t from './transformers';

export const getCountCard = {
  totals_merchants: () => {
    req.get({
      key: `${c.COUNT_CARD}/totals_merchants`,
      url: '/profile/v1/my/merchants',
      transform: (res) => ({
        value: formatNumber((res?.data || []).length, 0), // FIXME: must be from pagination
        rawValue: (res?.data || []).length,
      }),
    });
  },
  totals_channels: () => {
    req.set(`${c.COUNT_CARD}/totals_channels`, { value: formatNumber(2, 0) });
  },
  total_transactions: () => {
    reqLoader(`${c.COUNT_CARD}/total_transactions`, false);
    reqLoader(`${c.COUNT_CARD}/total_amount`, false);
    req.set(`${c.COUNT_CARD}/total_transactions`, {
      value: formatNumber(3, 0),
    });
    req.set(`${c.COUNT_CARD}/total_amount`, { value: formatCurrency(4) });
  },
};

export const getDashboardHistogram = (params, id = 'default') => {
  req.get({
    key: `${c.DASHBOARD_HISTOGRAM}/${id}`,
    url: `/wallet/v1/merchant/transactions/graph`,
    params,
    transform: t.transformDashboardHistogram(params),
  });
};

export const getDashboardScheme = (params, id) => {
  req.get({
    key: `${c.DASHBOARD_SCHEME}/${id}`,
    url: '/wallet/v1/merchant/transactions/graph',
    params,
    transform: t.transformDashboardScheme(),
  });
};

export const listTransaction = (params) => {
  req.get({
    key: c.TRANSACTION_LIST,
    url: `/wallet/v1/merchant/transactions`,
    params: formatSort(params),
    transform: (res) => (res.data || []).map(t.transformTransaction),
    onSuccess: (res) => {
      const meta = res?.response?.meta;
      req.set(
        c.TRANSACTION_PAGER,
        {
          current_page: meta?.current_page,
          total_pages: meta?.last_page,
          total: meta?.total,
        } || {}
      );
      req.set(c.TRANSACTION_FILTER, params);
    },
  });
};

export const selectedBillerTransaction = (transactionId) => {
  req.get({
    key: `${c.TRANSACTION_SELECTED}`,
    url: `/wallet/v1/merchant/transactions/${transactionId}`,
    transform: ({ data }) => t.transformSelectedTransaction(data),
  });
};

// export const selectedOrgTransaction = (merchantId, transactionId) => {
//   req.get({
//     key: `${c.TRANSACTION_SELECTED}`,
//     url: ``
//   })
// }

export const transactionTotal = (params) => {
  req.get({
    key: c.TRANSACTION_TOTAL,
    url: `/wallet/v1/merchant/transactions/accumulated_totals`,
    params,
  });
};

// BILLER
export const billerCountCards = (id) => {
  req.get({
    key: c.BILLER_COUNT_CARDS,
    url: `/wallet/v1/biller_mgmt/billers/${id}/dashboard/overall_total`,
    transform: (res) => t.transformCountCards(res),
  });
};

export const getBillerTransactionHistogram = (id, params) => {
  req.get({
    key: c.BILLER_TRANSACTION,
    params: {
      year: params?.year,
    },
    url: `/wallet/v1/biller_mgmt/billers/${id}/dashboard/total_transaction`,
    transform: (data) => t.transformTransactionHistogram(data),
  });
};

export const getBillerAmtHistogram = (id, params) => {
  req.get({
    key: c.BILLER_BY_AMOUNT,
    params: {
      year: params?.year,
    },
    url: `/wallet/v1/biller_mgmt/billers/${id}/dashboard/total_amount`,
    transform: (data) => t.transformAmtHistogram(data),
  });
};

export const billerComparativeTransaction = (id, params) => {
  req.get({
    key: c.BILLER_COMPARATIVE_TRANSACTION,
    url: `/wallet/v1/biller_mgmt/billers/${id}/dashboard/comparative_transaction`,
    params,
    transform: (res) => t.transformComparativeTransaction(res),
  });
};

// ORGANIZATION
export const organizationCountCards = (id) => {
  req.get({
    key: c.ORGANIZATION_COUNT_CARDS,
    url: `/wallet/v1/biller_mgmt/organizations/${id}/dashboard/overall_total`,
    transform: (res) => t.transformOrganizationCountCards(res),
  });
};

export const getOrganizationTransactionHistogram = (id, params) => {
  req.get({
    key: c.ORGANIZATION_TRANSACTION,
    params: {
      year: params?.year,
    },
    url: `/wallet/v1/biller_mgmt/organizations/${id}/dashboard/total_transaction`,
    transform: (data) => t.transformTransactionHistogram(data),
  });
};

export const organizationTopBillers = (id) => {
  req.get({
    key: c.ORGANIZATION_TOP_BILLERS,
    url: `/wallet/v1/biller_mgmt/organizations/${id}/dashboard/top_billers`,
    transform: (res) => t.transformOrganizationTopBiller(res),
  });
};

export const organizationTopBillerTypes = (id) => {
  req.get({
    key: c.ORGANIZATION_TOP_BILLER_TYPES,
    url: `/wallet/v1/biller_mgmt/organizations/${id}/dashboard/top_biller_types`,
    transform: (res) => t.transformOrganizationTopBillerType(res),
  });
};

export const organizationComparativeTransaction = (id, params) => {
  req.get({
    key: c.ORGANIZATION_COMPARATIVE_TRANSACTION,
    url: `/wallet/v1/biller_mgmt/organizations/${id}/dashboard/comparative_transaction`,
    params,
    transform: (res) => t.transformComparativeTransaction(res),
  });
};

export const requestDisputeTransaction = (onSuccess, onError) => (
  payload,
  onInlineSucess,
  onInlineError
) => {
  req.post({
    key: c.TRANSACTION_DISPUTE_REQUEST,
    url: '/wallet/v1/biller_portal/dispute/request',
    payload: t.transformDisputePayload(payload),
    onSuccess: () => {
      if (typeof onSuccess === 'function') onSuccess();
      if (typeof onInlineSucess === 'function') onInlineSucess();
    },
    onError: () => {
      if (typeof onError === 'function') onError();
      if (typeof onInlineError === 'function') onInlineError();
    },
  });
};
